import { render, staticRenderFns } from "./StudentMainPage.vue?vue&type=template&id=86df49c8&scoped=true&"
import script from "./StudentMainPage.vue?vue&type=script&lang=ts&"
export * from "./StudentMainPage.vue?vue&type=script&lang=ts&"
import style0 from "./StudentMainPage.vue?vue&type=style&index=0&id=86df49c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86df49c8",
  null
  
)

export default component.exports